// API configuration and services for Texas Showdown
//export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL + '/api';
//stupid thing doesn't work right in production
export const API_BASE_URL = 'https://txshowdown.azurewebsites.net/api';
export const ScheduleBlockType = {
    Game: 0,
    Registration: 1,
    Merchandise: 2,
};
class ApiService {
    async fetchWithTimeout(url, options = {}, timeout = 10000) {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), timeout);
        try {
            const response = await fetch(url, {
                ...options,
                signal: controller.signal,
                headers: {
                    'Content-Type': 'application/json',
                    ...options.headers,
                },
            });
            clearTimeout(timeoutId);
            return response;
        }
        catch (error) {
            clearTimeout(timeoutId);
            throw error;
        }
    }
    async getImageGalleryByYear(year) {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/ImageGallery/${year}`, {
                method: 'GET',
            });
            if (!response.ok) {
                if (response.status === 404) {
                    return null;
                }
                throw new Error(`API error: ${response.status} ${response.statusText}`);
            }
            const data = await response.json();
            return data.message || null;
        }
        catch (error) {
            console.error(`Error fetching image gallery for year ${year}:`, error);
            throw error;
        }
    }
    async getAllGalleryPreviews() {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/ImageGallery/allpreviews`, {
                method: 'GET',
            }, 30000);
            if (!response.ok) {
                throw new Error(`API error: ${response.status} ${response.statusText}`);
            }
            const data = await response.json();
            return data.message || [];
        }
        catch (error) {
            console.error('Error fetching all gallery previews:', error);
            throw error;
        }
    }
    async getPreviewImages(year) {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/ImageGallery/${year}/preview`, {
                method: 'GET',
            });
            if (!response.ok) {
                if (response.status === 404) {
                    return [];
                }
                throw new Error(`API error: ${response.status} ${response.statusText}`);
            }
            const data = await response.json();
            return data.message || [];
        }
        catch (error) {
            console.error(`Error fetching preview images for year ${year}:`, error);
            throw error;
        }
    }
    async getMainTournaments() {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/Results/main`, {
                method: 'GET',
            });
            if (!response.ok) {
                throw new Error(`API error: ${response.status} ${response.statusText}`);
            }
            const data = await response.json();
            return data.message || [];
        }
        catch (error) {
            console.error('Error fetching main tournaments:', error);
            throw error;
        }
    }
    async getScbTournaments() {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/Results/scb`, {
                method: 'GET',
            });
            if (!response.ok) {
                throw new Error(`API error: ${response.status} ${response.statusText}`);
            }
            const data = await response.json();
            return data.message || [];
        }
        catch (error) {
            console.error('Error fetching SCB tournaments:', error);
            throw error;
        }
    }
    async getTournamentResults(tournamentId) {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/Results/${tournamentId}`, {
                method: 'GET',
            });
            if (!response.ok) {
                if (response.status === 404) {
                    return null;
                }
                throw new Error(`API error: ${response.status} ${response.statusText}`);
            }
            const data = await response.json();
            return data.message || null;
        }
        catch (error) {
            console.error(`Error fetching results for tournament ${tournamentId}:`, error);
            throw error;
        }
    }
    async getVendors() {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/Home/vendors`, {
                method: 'GET',
            });
            if (!response.ok) {
                throw new Error(`API error: ${response.status} ${response.statusText}`);
            }
            const data = await response.json();
            return data.message || [];
        }
        catch (error) {
            console.error('Error fetching vendors:', error);
            throw error;
        }
    }
    async getArtists() {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/Home/artists`, {
                method: 'GET',
            });
            if (!response.ok) {
                throw new Error(`API error: ${response.status} ${response.statusText}`);
            }
            const data = await response.json();
            return data.message || [];
        }
        catch (error) {
            console.error('Error fetching artists:', error);
            throw error;
        }
    }
    // this call is only for the commentators page
    async getTournamentCommentators() {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/api/commentators`, {
                method: 'GET',
            });
            if (!response.ok) {
                throw new Error(`API error: ${response.status} ${response.statusText}`);
            }
            const data = await response.json();
            return data.message || [];
        }
        catch (error) {
            console.error('Error fetching tournament commentators:', error);
            throw error;
        }
    }
    async getHistoricalTournaments() {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/History/alltournaments`, {
                method: 'GET',
            });
            if (!response.ok) {
                throw new Error(`API error: ${response.status} ${response.statusText}`);
            }
            const data = await response.json();
            return data.message || [];
        }
        catch (error) {
            console.error('Error fetching historical tournaments:', error);
            throw error;
        }
    }
    async getGames() {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/Games`, {
                method: 'GET',
            });
            if (!response.ok) {
                throw new Error(`API error: ${response.status} ${response.statusText}`);
            }
            const data = await response.json();
            return data.message || [];
        }
        catch (error) {
            console.error('Error fetching games:', error);
            throw error;
        }
    }
    async getStreams() {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/Stream`, { method: 'GET' });
            if (!response.ok)
                throw new Error(`API error: ${response.status}`);
            const data = await response.json();
            return data.message || [];
        }
        catch (error) {
            console.error('Error fetching streams:', error);
            throw error;
        }
    }
    async getCommentators() {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/Commentator`, { method: 'GET' });
            if (!response.ok)
                throw new Error(`API error: ${response.status}`);
            const data = await response.json();
            return data.message || [];
        }
        catch (error) {
            console.error('Error fetching commentators:', error);
            throw error;
        }
    }
    async getTxsUsers() {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/TxsUser`, { method: 'GET' });
            if (!response.ok)
                throw new Error(`API error: ${response.status}`);
            const data = await response.json();
            return data.message || [];
        }
        catch (error) {
            console.error('Error fetching TxsUsers:', error);
            throw error;
        }
    }
    async getAvailableUsers(blockStart, blockEnd) {
        try {
            const params = new URLSearchParams({ blockStart, blockEnd });
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/TxsUser/available?${params}`, { method: 'GET' });
            if (!response.ok)
                throw new Error(`API error: ${response.status}`);
            const data = await response.json();
            return data.message || [];
        }
        catch (error) {
            console.error('Error fetching available users:', error);
            throw error;
        }
    }
    async getAllPoolViews() {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/ScheduleBlockPool/views`, { method: 'GET' });
            if (!response.ok)
                throw new Error(`API error: ${response.status}`);
            const data = await response.json();
            return data.message || [];
        }
        catch (error) {
            console.error('Error fetching pool views:', error);
            throw error;
        }
    }
    async getAllPoolEntries() {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/ScheduleBlockPool`, { method: 'GET' });
            if (!response.ok)
                throw new Error(`API error: ${response.status}`);
            const data = await response.json();
            return data.message || [];
        }
        catch (error) {
            console.error('Error fetching all pool entries:', error);
            throw error;
        }
    }
    async getPoolEntriesByBlock(scheduleBlockId) {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/ScheduleBlockPool/block/${scheduleBlockId}`, { method: 'GET' });
            if (!response.ok)
                throw new Error(`API error: ${response.status}`);
            const data = await response.json();
            return data.message || [];
        }
        catch (error) {
            console.error('Error fetching pool entries:', error);
            throw error;
        }
    }
    async createPoolEntry(entry) {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/ScheduleBlockPool`, {
                method: 'POST',
                body: JSON.stringify(entry),
            });
            if (!response.ok)
                throw new Error(`API error: ${response.status}`);
            const data = await response.json();
            return data.message;
        }
        catch (error) {
            console.error('Error creating pool entry:', error);
            throw error;
        }
    }
    async updatePoolEntry(id, entry) {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/ScheduleBlockPool/${id}`, {
                method: 'PUT',
                body: JSON.stringify(entry),
            });
            if (!response.ok)
                throw new Error(`API error: ${response.status}`);
            const data = await response.json();
            return data.message;
        }
        catch (error) {
            console.error('Error updating pool entry:', error);
            throw error;
        }
    }
    async deletePoolEntry(id) {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/ScheduleBlockPool/${id}`, { method: 'DELETE' });
            if (!response.ok)
                throw new Error(`API error: ${response.status}`);
            return true;
        }
        catch (error) {
            console.error('Error deleting pool entry:', error);
            throw error;
        }
    }
    async createBlock(block) {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/Schedule/blocks`, {
                method: 'POST',
                body: JSON.stringify(block),
            });
            if (!response.ok)
                throw new Error(`API error: ${response.status}`);
            const data = await response.json();
            return data.message;
        }
        catch (error) {
            console.error('Error creating schedule block:', error);
            throw error;
        }
    }
    async updateBlock(id, block) {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/Schedule/updateblock/${id}`, {
                method: 'PUT',
                body: JSON.stringify(block),
            });
            if (!response.ok)
                throw new Error(`API error: ${response.status}`);
            const data = await response.json();
            return data.message;
        }
        catch (error) {
            console.error('Error updating schedule block:', error);
            throw error;
        }
    }
    async deleteBlock(id) {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/Schedule/deleteblock/${id}`, { method: 'DELETE' });
            if (!response.ok)
                throw new Error(`API error: ${response.status}`);
            return true;
        }
        catch (error) {
            console.error('Error deleting schedule block:', error);
            throw error;
        }
    }
    async getScheduleBlocks() {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/Schedule/blocks`, {
                method: 'GET',
            });
            if (!response.ok) {
                throw new Error(`API error: ${response.status} ${response.statusText}`);
            }
            const data = await response.json();
            return data.message || [];
        }
        catch (error) {
            console.error('Error fetching schedule blocks:', error);
            throw error;
        }
    }
    async getBlocksByType(blockType) {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/Schedule/blocks/type/${blockType}`, { method: 'GET' });
            if (!response.ok)
                throw new Error(`API error: ${response.status}`);
            const data = await response.json();
            return data.message || [];
        }
        catch (error) {
            console.error('Error fetching schedule blocks by type:', error);
            throw error;
        }
    }
    async getAllVolunteerEntries() {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/ScheduleBlockVolunteer`, { method: 'GET' });
            if (!response.ok)
                throw new Error(`API error: ${response.status}`);
            const data = await response.json();
            return data.message || [];
        }
        catch (error) {
            console.error('Error fetching all volunteer entries:', error);
            throw error;
        }
    }
    async getVolunteerEntriesByBlock(scheduleBlockId) {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/ScheduleBlockVolunteer/block/${scheduleBlockId}`, { method: 'GET' });
            if (!response.ok)
                throw new Error(`API error: ${response.status}`);
            const data = await response.json();
            return data.message || [];
        }
        catch (error) {
            console.error('Error fetching volunteer entries:', error);
            throw error;
        }
    }
    async createVolunteerEntry(entry) {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/ScheduleBlockVolunteer`, {
                method: 'POST',
                body: JSON.stringify(entry),
            });
            if (!response.ok)
                throw new Error(`API error: ${response.status}`);
            const data = await response.json();
            return data.message;
        }
        catch (error) {
            console.error('Error creating volunteer entry:', error);
            throw error;
        }
    }
    async updateVolunteerEntry(id, entry) {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/ScheduleBlockVolunteer/${id}`, {
                method: 'PUT',
                body: JSON.stringify(entry),
            });
            if (!response.ok)
                throw new Error(`API error: ${response.status}`);
            const data = await response.json();
            return data.message;
        }
        catch (error) {
            console.error('Error updating volunteer entry:', error);
            throw error;
        }
    }
    async deleteVolunteerEntry(id) {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/ScheduleBlockVolunteer/${id}`, { method: 'DELETE' });
            if (!response.ok)
                throw new Error(`API error: ${response.status}`);
            return true;
        }
        catch (error) {
            console.error('Error deleting volunteer entry:', error);
            throw error;
        }
    }
    async getHistoricalTournamentByYear(year) {
        try {
            const response = await this.fetchWithTimeout(`${API_BASE_URL}/History/historical/${year}`, {
                method: 'GET',
            });
            if (!response.ok) {
                if (response.status === 404) {
                    return null;
                }
                throw new Error(`API error: ${response.status} ${response.statusText}`);
            }
            const data = await response.json();
            return data.message || null;
        }
        catch (error) {
            console.error(`Error fetching historical tournament for year ${year}:`, error);
            throw error;
        }
    }
}
export const apiService = new ApiService();
